module.exports = __webpack_public_path__ + "img/easy_bg02.55496d0a.png";